import React, { useLayoutEffect } from "react";
import { Card } from "react-bootstrap";
import MessageHeader from "./MessageHeader";
import ChatInput from "./ChatInput";
import MessageListScroll from "./MessageListScroll";
import { BsChatSquareText } from "react-icons/bs";
import { useSelector } from "react-redux";
import moment from "moment";

function MessagesList({
  messageList,
  isChatFetching,
  conversationSelectedTrue,
  userId,
  userName,
}) {
  const selectedConversation = useSelector(
    (state) => state.session.selectedConversationDetails
  );

  console.log(selectedConversation, "messageList");

  // ✅ Mobile toggle fix
  function toggleFunc() {
    const element = document.getElementById("chat-message");
    element?.classList.add("mystyle");
  }

  useLayoutEffect(() => {
    if (window.innerWidth < 500) {
      toggleFunc();
    }
  }, [conversationSelectedTrue]);

  // ✅ Group messages by date
  const groupMessagesByDate = (messages) => {
    const groups = {};
    messages?.forEach((message) => {
      const date = moment(message.messageTime).format("YYYY-MM-DD");
      if (!groups[date]) groups[date] = [];
      groups[date].push(message);
    });
    return groups;
  };

  // ✅ Handle message types for PDF
  const getPdfMessageByType = (msg) => {
    switch (msg.type) {
      case "message":
        return msg.message;

      case "document":
        return `Document: ${msg.message}\nLink: ${msg.documentLink || ""}`;

      case "image":
        return `Image: ${
          "" + msg.url ||
          "" + msg.mediaLink
        }`;

      case "video":
        return `Video: ${
          "" + msg.url ||
          "" + msg.mediaLink
        }`;

      default:
        return msg.message;
    }
  };

  // ✅ PDF Export Function
  const exportChatAsPDF = async () => {
    const { jsPDF } = await import("jspdf");
    const pdf = new jsPDF("p", "pt", "a4");

    const marginLeft = 20;
    const marginTop = 30;
    let y = marginTop;

    pdf.setFont("Helvetica", "normal");
    pdf.setFontSize(12);

    pdf.text("User Name (Me): " + userName, marginLeft, y);
    y += 20;
    pdf.text("User ID (Me): " + userId, marginLeft, y);
    y += 20;
    pdf.text(
      "Other User Name: " + selectedConversation?.otherPersonName,
      marginLeft,
      y
    );
    y += 20;
    pdf.text(
      "Other User ID: " + selectedConversation?.otherPersonId,
      marginLeft,
      y
    );
    y += 20;
    pdf.text("Chat History", marginLeft, y);
    y += 20;

    Object.entries(groupMessagesByDate(messageList)).forEach(
      ([date, messages]) => {
        // ✅ Date separator
        pdf.setFontSize(14);
        pdf.text(moment(date).format("MMMM D, YYYY"), marginLeft, y);
        y += 20;

        messages.forEach((msg) => {
          // ✅ Type handling
          let content = getPdfMessageByType(msg);

          let senderName =
            msg.sender === userId
              ? "Me"
              : selectedConversation?.otherPersonName || "User";

          let time = moment(msg.messageTime).format("h:mm A");

          let fullLine = `${senderName} (${time}): ${content}`;

          const textLines = pdf.splitTextToSize(fullLine, 550);

          // ✅ Page overflow handling
          if (y + textLines.length * 14 > 800) {
            pdf.addPage();
            y = marginTop;
          }

          pdf.setFontSize(12);
          pdf.text(textLines, marginLeft, y);

          y += textLines.length * 14 + 10;
        });

        y += 10;
      }
    );

    const fileName = `${selectedConversation?.otherPersonName || "Chat"}.pdf`;
    pdf.save(fileName);
  };

  return (
    <Card id="chat-message" className="message-list shadow-md">
      {" "}
      {conversationSelectedTrue && (
        <>
          {" "}
          <MessageHeader
            userId={userId}
            handleExportPDF={exportChatAsPDF}
          />{" "}
          <MessageListScroll
            messageList={messageList}
            isChatFetching={isChatFetching}
            userId={userId}
          />{" "}
        </>
      )}{" "}
      {!conversationSelectedTrue && (
        <div className="no-conversation-container">
          {" "}
          <div className="message-container">
            {" "}
            <BsChatSquareText size={"100px"} color={"#a6f9fe"} />{" "}
            <p className="message">Please select a chat to continue</p>{" "}
          </div>{" "}
        </div>
      )}{" "}
    </Card>
  );
}

export default MessagesList;
